// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------
// A whole-number Order input that shows 0 as "0" (R4-E4). The shared
// RHFTextField renders a numeric 0 as an empty box, which other screens rely
// on, so the program form uses this local field instead of changing it.
// The value is kept as a Number ('' while the box is empty, which the form's
// rules report as "Order must be a number").

type Props = { name: string } & Omit<TextFieldProps, 'name' | 'value' | 'onChange' | 'type'>;

export default function RHFOrderField({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          type="number"
          fullWidth
          autoComplete="off"
          value={field.value === undefined || field.value === null ? '' : String(field.value)}
          onChange={(e) => field.onChange(e.target.value === '' ? '' : Number(e.target.value))}
          inputProps={{ min: 0, step: 1, inputMode: 'numeric' }}
          {...other}
          error={!!error}
          helperText={error?.message ?? helperText}
        />
      )}
    />
  );
}
